(() => {
  const yellow = '#ffd400';
  const black = '#000000';
  const styleId = 'vdm-chat-brand-refinements';
  const styleText = `
    :host {
      --vdm-chat-bottom: max(16px, calc(25vh + env(safe-area-inset-bottom, 0px)));
      --vdm-chat-side: max(16px, env(safe-area-inset-right, 0px));
    }

    .activator {
      position: fixed !important;
      top: auto !important;
      left: auto !important;
      right: var(--vdm-chat-side) !important;
      bottom: var(--vdm-chat-bottom) !important;
      transform: none !important;
      z-index: 2147483000 !important;
      background: ${yellow} !important;
      background-color: ${yellow} !important;
      color: ${black} !important;
      border-color: ${yellow} !important;
      opacity: 1 !important;
    }

    .activator:hover,
    .activator:focus-visible {
      background: ${yellow} !important;
      background-color: ${yellow} !important;
      color: ${black} !important;
      border-color: ${yellow} !important;
      opacity: 1 !important;
    }

    .activator *,
    .activator__label {
      color: ${black} !important;
    }

    .activator svg,
    .activator svg * {
      color: ${black} !important;
      stroke: ${black} !important;
    }

    .activator svg [fill]:not([fill="none"]) {
      fill: ${black} !important;
    }
  `;
  let scheduled = false;

  const apply = () => {
    scheduled = false;
    document.querySelectorAll('shopify-chat').forEach((chat) => {
      const root = chat.shadowRoot;
      if (!root) return;
      let style = root.querySelector(`#${styleId}`);
      if (!style) {
        style = document.createElement('style');
        style.id = styleId;
        root.appendChild(style);
      }
      if (style.textContent !== styleText) style.textContent = styleText;
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  if (window.customElements?.whenDefined) {
    window.customElements.whenDefined('shopify-chat').then(schedule).catch(() => {});
  }

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', schedule, { capture: true, passive: true });
  document.addEventListener('focusin', schedule, { capture: true, passive: true });
})();
